module.exports = __webpack_public_path__ + "img/LOGO_PETRONAS_DARK.8727959c.png";